import { AmplifyPost } from '@sunrun/sales-experience-shared/amplify-api-wrapper';
import { logger } from './logger';

type ProposalEmailType = 'ONE_PROPOSAL' | 'UTILITY_WELCOME';

const sendProposalEmail = async (
  hybridToken: string,
  prospectId: string,
  optionalNote = '',
  emailType: ProposalEmailType = 'ONE_PROPOSAL',
) => {
  await AmplifyPost(
    'Send Proposal Email',
    'SalesExpDashboardApi',
    `/prospect/${prospectId}/sendProposalEmail`,
    {
      headers: {
        Authorization: `Bearer ${hybridToken}`,
      },
      body: {
        optionalNote,
        emailType,
      },
    },
    logger,
    {
      expectedErrorCodes: [401, 403],
    },
  );
};

const sendProposalMessageAndEmail = async (
  hybridToken: string,
  prospectId: string,
  optionalNote = '',
  emailType: ProposalEmailType = 'ONE_PROPOSAL',
) => {
  await AmplifyPost(
    'Send Proposal Message And Email',
    'SalesExpDashboardApi',
    `/prospect/${prospectId}/sendProposalMessageAndEmail`,
    {
      headers: {
        Authorization: `Bearer ${hybridToken}`,
      },
      body: {
        optionalNote,
        emailType,
      },
    },
    logger,
    {
      expectedErrorCodes: [401, 403],
    },
  );
};

export { sendProposalEmail, sendProposalMessageAndEmail };
export type { ProposalEmailType };
